export interface Errors {
  [name: string]: string[];
}

// Функция-костыль - убирает аттрибуты с повторяющимися сообщениями из объекта errors 
// TODO: нужно подумать, как доработать/переработать VeeValidate в компонентах чтобы отсюда убрать это.
export function cutErrors(errors: Errors): Errors {
  let newErrors: Errors = {};
  const errorKeys: string[] = Object.keys(errors);
  errorKeys.forEach((key: string) => {
    if (!isMessageAlreadyThere(newErrors, errors[key][0])) {
      newErrors[key] = errors[key];
    }
  });
  return newErrors;
}

// Функция проверки, что в объекте errors уже есть ошибка с текстом errorText 
export function isMessageAlreadyThere(errors: Errors, errorText: string | undefined): boolean {
  let result: boolean = false;
  const errorKeys: string[] = Object.keys(errors);
  if (errorText !== undefined) {
    errorKeys.forEach((key: string) => {
      result = result || (errors[key].includes(errorText));
    });
  }
  return result;
}